import React, { useState, useMemo } from 'react'; // useMemo se mantiene para seccionesFiltradas
import { useDia } from '../hooks/usePlanOperativo';

const VACIO = {
  id_cp: '', actividad_id: '', seccion_id: '',
  jornales_ejecutados: '', cantidad_ejecutada: '',
  unidad: '', operarios_campo: '', contratistas: '',
  incapacitados: '', permisos: '', observaciones: '',
  registrado_por: '',
};

const VACIO_PLAN = {
  id_cp: '', actividad_id: '', fecha: '',
  jornales_planeados: '', meta_cantidad: '', observaciones: '',
};

export default function ModalDia({ fecha, secciones, actividades, esAdmin, fincas, planMes, guardarPlan, eliminarPlan, onClose }) {
  const [form, setForm] = useState(VACIO);
  const [formPlan, setFormPlan] = useState({ ...VACIO_PLAN, fecha });
  const [tab, setTab] = useState('registrar');
  const [editandoRegistroId, setEditandoRegistroId] = useState(null);
  const [editandoPlanId, setEditandoPlanId] = useState(null);
  const { registros, guardar, eliminar, guardando, error: errorGuardar } = useDia(fecha);

  const fechaFormateada = new Date(fecha + 'T12:00:00').toLocaleDateString('es-CO', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  });


  // Admin: filtra secciones por la finca seleccionada en el formulario
  const seccionesFiltradas = useMemo(() => {
    if (!esAdmin || !form.id_cp) return secciones;
    return secciones.filter(sec => sec.id_cp === parseInt(form.id_cp));
  }, [secciones, esAdmin, form.id_cp]);

  const actSeleccionada = actividades.find(a => a.id === parseInt(form.actividad_id));
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const setPlan = (k, v) => setFormPlan(f => ({ ...f, [k]: v }));

  const planDelDia = useMemo(() =>
    (planMes || []).filter(p => p.fecha?.slice(0, 10) === fecha),
    [planMes, fecha]
  );

  const resetFormRegistro = () => {
    setForm(VACIO);
    setEditandoRegistroId(null);
  };

  const resetFormPlan = () => {
    setFormPlan({ ...VACIO_PLAN, fecha });
    setEditandoPlanId(null);
  };

  const iniciarEdicionRegistro = (registro) => {
    setForm({
      id_cp: registro.id_cp ? String(registro.id_cp) : '',
      actividad_id: registro.actividad_id ? String(registro.actividad_id) : '',
      seccion_id: registro.seccion_id ? String(registro.seccion_id) : '',
      jornales_ejecutados: registro.jornales_ejecutados != null ? String(registro.jornales_ejecutados) : '',
      cantidad_ejecutada: registro.cantidad_ejecutada != null ? String(registro.cantidad_ejecutada) : '',
      unidad: registro.unidad || '',
      operarios_campo: registro.operarios_campo != null ? String(registro.operarios_campo) : '',
      contratistas: registro.contratistas != null ? String(registro.contratistas) : '',
      incapacitados: registro.incapacitados != null ? String(registro.incapacitados) : '',
      permisos: registro.permisos != null ? String(registro.permisos) : '',
      observaciones: registro.observaciones || '',
      registrado_por: registro.registrado_por || '',
    });
    setEditandoRegistroId(registro.id);
    setTab('registrar');
  };

  const iniciarEdicionPlan = (plan) => {
    setFormPlan({
      id_cp: plan.id_cp ? String(plan.id_cp) : '',
      actividad_id: plan.actividad_id ? String(plan.actividad_id) : '',
      fecha: plan.fecha?.slice(0, 10) || fecha,
      jornales_planeados: plan.jornales_planeados != null ? String(plan.jornales_planeados) : '',
      meta_cantidad: plan.meta_cantidad != null ? String(plan.meta_cantidad) : '',
      observaciones: plan.observaciones || '',
    });
    setEditandoPlanId(plan.id);
    setTab('plan');
  };

  const handleGuardar = async () => {
    if (esAdmin && !form.id_cp) {
      alert('Selecciona la finca');
      return;
    }
    if (!form.actividad_id || !form.seccion_id || !form.jornales_ejecutados) {
      alert('Completa: Actividad, Sección y Jornales ejecutados');
      return;
    }
    await guardar({
      id: editandoRegistroId || undefined,
      ...(esAdmin ? { id_cp: parseInt(form.id_cp) } : {}),
      actividad_id:        parseInt(form.actividad_id),
      seccion_id:          parseInt(form.seccion_id),
      jornales_ejecutados: parseInt(form.jornales_ejecutados),
      cantidad_ejecutada:  form.cantidad_ejecutada ? parseFloat(form.cantidad_ejecutada) : null,
      unidad:              actSeleccionada?.unidad_medida || form.unidad,
      operarios_campo:     parseInt(form.operarios_campo)  || 0,
      contratistas:        parseInt(form.contratistas)     || 0,
      incapacitados:       parseInt(form.incapacitados)    || 0,
      permisos:            parseInt(form.permisos)         || 0,
      observaciones:       form.observaciones,
      registrado_por:      form.registrado_por,
    });
    resetFormRegistro();
    setTab('ver');
  };

  const handleGuardarPlan = async () => {
    if (esAdmin && !formPlan.id_cp) {
      alert('Selecciona la finca');
      return;
    }
    if (!formPlan.actividad_id || !formPlan.jornales_planeados) {
      alert('Completa: Actividad y jornales planeados');
      return;
    }

    await guardarPlan({
      id: editandoPlanId || undefined,
      ...(esAdmin ? { id_cp: parseInt(formPlan.id_cp) } : {}),
      actividad_id: parseInt(formPlan.actividad_id),
      fecha: formPlan.fecha || fecha,
      jornales_planeados: parseInt(formPlan.jornales_planeados),
      meta_cantidad: formPlan.meta_cantidad ? parseFloat(formPlan.meta_cantidad) : null,
      observaciones: formPlan.observaciones,
    });

    resetFormPlan();
    setTab('plan');
  };

  const handleEliminarPlan = async (id) => {
    await eliminarPlan(id);
  };

  return (
    <div style={s.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={s.sheet}>

        <div style={s.handle} />
        <div style={s.sheetHeader}>
          <div>
            <p style={s.fechaTxt}>{fechaFormateada}</p>
            <p style={s.registrosCnt}>{registros.length} registro{registros.length !== 1 ? 's' : ''} en este día</p>
          </div>
          <button style={s.closeBtn} onClick={onClose} aria-label="Cerrar">✕</button>
        </div>

        <div style={s.tabs}>
          <button style={{ ...s.tab, ...(tab === 'registrar' ? s.tabActive : {}) }}
                  onClick={() => setTab('registrar')}>
            + Registrar actividad
          </button>
          <button style={{ ...s.tab, ...(tab === 'plan' ? s.tabActive : {}) }}
                  onClick={() => setTab('plan')}>
            📋 Plan operativo ({planDelDia.length})
          </button>
          <button style={{ ...s.tab, ...(tab === 'ver' ? s.tabActive : {}) }}
                  onClick={() => setTab('ver')}>
            Ver registros ({registros.length})
          </button>
        </div>

        {tab === 'registrar' && (
          <div style={s.formArea}>

            {esAdmin && (
              <Field label="Finca *">
                <select value={form.id_cp}
                        onChange={e => set('id_cp', e.target.value)}
                        style={s.input}>
                  <option value="">-- Seleccionar finca --</option>
                  {(fincas || []).map(f => (
                    <option key={f.id} value={f.id}>{f.nombre}</option>
                  ))}
                </select>
              </Field>
            )}

            <Field label="Actividad *">
              <select value={form.actividad_id}
                      onChange={e => set('actividad_id', e.target.value)}
                      style={s.input}>
                <option value="">-- Seleccionar actividad --</option>
                {actividades.map(a => (
                  <option key={a.id} value={a.id}>{a.nombre}</option>
                ))}
              </select>
            </Field>

            <Field label="Sección *">
              <select value={form.seccion_id}
                      onChange={e => set('seccion_id', e.target.value)}
                      style={s.input}>
                <option value="">-- Seleccionar sección --</option>
                {seccionesFiltradas.map(sec => (
                  <option key={sec.id} value={sec.id}>
                    {esAdmin ? `${sec.finca_nombre} · ${sec.nombre}` : sec.nombre}
                  </option>
                ))}
              </select>
            </Field>

            <div style={s.row2}>
              <Field label="Jornales ejecutados *">
                <input type="number" min="0" value={form.jornales_ejecutados}
                       onChange={e => set('jornales_ejecutados', e.target.value)}
                       style={s.input} placeholder="Ej: 14" />
              </Field>
              <Field label={`Cantidad (${actSeleccionada?.unidad_medida || 'unidades'})`}>
                <input type="number" min="0" value={form.cantidad_ejecutada}
                       onChange={e => set('cantidad_ejecutada', e.target.value)}
                       style={s.input} placeholder="Ej: 500" />
              </Field>
            </div>

            <div style={s.row2}>
              <Field label="Operarios en campo">
                <input type="number" min="0" value={form.operarios_campo}
                       onChange={e => set('operarios_campo', e.target.value)}
                       style={s.input} placeholder="0" />
              </Field>
              <Field label="Contratistas">
                <input type="number" min="0" value={form.contratistas}
                       onChange={e => set('contratistas', e.target.value)}
                       style={s.input} placeholder="0" />
              </Field>
            </div>

            <div style={s.row2}>
              <Field label="Incapacitados">
                <input type="number" min="0" value={form.incapacitados}
                       onChange={e => set('incapacitados', e.target.value)}
                       style={s.input} placeholder="0" />
              </Field>
              <Field label="Permisos">
                <input type="number" min="0" value={form.permisos}
                       onChange={e => set('permisos', e.target.value)}
                       style={s.input} placeholder="0" />
              </Field>
            </div>

            <Field label="Observaciones">
              <textarea value={form.observaciones}
                        onChange={e => set('observaciones', e.target.value)}
                        style={{ ...s.input, minHeight: 70, resize: 'vertical' }}
                        placeholder="Novedades del día, condiciones del campo..." />
            </Field>

            <Field label="Registrado por">
              <input type="text" value={form.registrado_por}
                     onChange={e => set('registrado_por', e.target.value)}
                     style={s.input} placeholder="Nombre del responsable" />
            </Field>

            {errorGuardar && (
              <div style={s.errorMsg}>⚠️ {errorGuardar}</div>
            )}
            {(editandoRegistroId || editandoPlanId) && (
              <button style={s.btnSecundario} onClick={() => { resetFormRegistro(); resetFormPlan(); setTab('registrar'); }}>
                Cancelar edición
              </button>
            )}
            <button style={s.btnGuardar} onClick={handleGuardar} disabled={guardando}>
              {guardando ? 'Guardando...' : editandoRegistroId ? '✏️ Actualizar registro' : '💾  Guardar registro'}
            </button>
          </div>
        )}

        {tab === 'plan' && (
          <div style={s.formArea}>
            {esAdmin && (
              <Field label="Finca *">
                <select value={formPlan.id_cp}
                        onChange={e => setPlan('id_cp', e.target.value)}
                        style={s.input}>
                  <option value="">-- Seleccionar finca --</option>
                  {(fincas || []).map(f => (
                    <option key={f.id} value={f.id}>{f.nombre}</option>
                  ))}
                </select>
              </Field>
            )}

            <Field label="Actividad *">
              <select value={formPlan.actividad_id}
                      onChange={e => setPlan('actividad_id', e.target.value)}
                      style={s.input}>
                <option value="">-- Seleccionar actividad --</option>
                {actividades.map(a => (
                  <option key={a.id} value={a.id}>{a.nombre}</option>
                ))}
              </select>
            </Field>

            <div style={s.row2}>
              <Field label="Jornales planeados *">
                <input type="number" min="0" value={formPlan.jornales_planeados}
                       onChange={e => setPlan('jornales_planeados', e.target.value)}
                       style={s.input} placeholder="Ej: 12" />
              </Field>
              <Field label="Meta cantidad">
                <input type="number" min="0" value={formPlan.meta_cantidad}
                       onChange={e => setPlan('meta_cantidad', e.target.value)}
                       style={s.input} placeholder="Ej: 500" />
              </Field>
            </div>

            <Field label="Observaciones">
              <textarea value={formPlan.observaciones}
                        onChange={e => setPlan('observaciones', e.target.value)}
                        style={{ ...s.input, minHeight: 70, resize: 'vertical' }}
                        placeholder="Detalle del plan operativo" />
            </Field>

            {(editandoRegistroId || editandoPlanId) && (
              <button style={s.btnSecundario} onClick={() => { resetFormRegistro(); resetFormPlan(); setTab('plan'); }}>
                Cancelar edición
              </button>
            )}
            <button style={s.btnGuardar} onClick={handleGuardarPlan}>
              {editandoPlanId ? '✏️ Actualizar plan operativo' : '💾 Guardar plan operativo'}
            </button>

            {planDelDia.length > 0 && (
              <div style={{ marginTop: 14 }}>
                <p style={s.sectionTitle}>Planes registrados para este día</p>
                {planDelDia.map(p => (
                  <div key={p.id} style={s.regCard}>
                    <div style={s.regHeader}>
                      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
                        <span style={{ ...s.catBadge, background: p.color_hex || '#1D9E75' }}>
                          plan
                        </span>
                        {esAdmin && (
                          <span style={{ ...s.catBadge, background: '#555' }}>
                            {p.finca_nombre}
                          </span>
                        )}
                      </div>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button style={s.delBtn} onClick={() => iniciarEdicionPlan(p)} aria-label="Editar plan">✏️</button>
                        <button style={s.delBtn} onClick={() => handleEliminarPlan(p.id)} aria-label="Eliminar plan">🗑</button>
                      </div>
                    </div>
                    <p style={s.regNombre}>{p.actividad_nombre}</p>
                    <div style={s.regMeta}>
                      <span>👷 {p.jornales_planeados} jornales</span>
                      {p.meta_cantidad !== null && p.meta_cantidad !== undefined && (
                        <span>📦 {p.meta_cantidad}</span>
                      )}
                    </div>
                    {p.observaciones && <p style={s.regObs}>"{p.observaciones}"</p>}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {tab === 'ver' && (
          <div style={s.formArea}>
            {registros.length === 0 ? (
              <div style={s.empty}>
                <p style={{ fontSize: 36 }}>📋</p>
                <p>Sin registros para este día.</p>
                <button style={s.btnSecundario} onClick={() => setTab('registrar')}>
                  Registrar ahora
                </button>
              </div>
            ) : registros.map(r => (
              <div key={r.id} style={s.regCard}>
                <div style={s.regHeader}>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
                    <span style={{ ...s.catBadge, background: r.color_hex || '#1D9E75' }}>
                      actividad
                    </span>
                    {esAdmin && (
                      <span style={{ ...s.catBadge, background: '#555' }}>
                        {r.finca_nombre}
                      </span>
                    )}
                  </div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button style={s.delBtn} onClick={() => iniciarEdicionRegistro(r)} aria-label="Editar">✏️</button>
                    <button style={s.delBtn} onClick={() => eliminar(r.id)} aria-label="Eliminar">🗑</button>
                  </div>
                </div>
                <p style={s.regNombre}>{r.actividad_nombre}</p>
                <div style={s.regMeta}>
                  <span>📍 {r.seccion_nombre}</span>
                  <span>👷 {r.jornales_ejecutados} jornales</span>
                  {r.cantidad_ejecutada && <span>📦 {r.cantidad_ejecutada} {r.unidad}</span>}
                </div>
                {r.operarios_campo > 0 && (
                  <div style={s.regPersonal}>
                    <span>Campo: {r.operarios_campo}</span>
                    {r.contratistas  > 0 && <span>Cont.: {r.contratistas}</span>}
                    {r.incapacitados > 0 && <span>Incap.: {r.incapacitados}</span>}
                    {r.permisos      > 0 && <span>Perm.: {r.permisos}</span>}
                  </div>
                )}
                {r.observaciones  && <p style={s.regObs}>"{r.observaciones}"</p>}
                {r.registrado_por && <p style={s.regBy}>Por: {r.registrado_por}</p>}
              </div>
            ))}
          </div>
        )}

      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 3 }}>{label}</label>
      {children}
    </div>
  );
}

const s = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)',
    display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 1000,
  },
  sheet: {
    background: '#fff', borderRadius: '16px 16px 0 0',
    width: '100%', maxWidth: 560, maxHeight: '90vh',
    overflowY: 'auto', paddingBottom: '2rem',
  },
  handle: { width: 36, height: 4, background: '#ddd', borderRadius: 2, margin: '12px auto 0' },
  sheetHeader: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
    padding: '12px 1.25rem 0',
  },
  fechaTxt:     { fontWeight: 600, fontSize: 15, color: '#0F6E56', margin: 0 },
  registrosCnt: { fontSize: 12, color: '#999', margin: '2px 0 0' },
  closeBtn:     { background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#999' },
  tabs:         { display: 'flex', borderBottom: '1px solid #eee', margin: '12px 0 0' },
  tab: {
    flex: 1, padding: '10px 4px', fontSize: 13, cursor: 'pointer',
    background: 'none', border: 'none', borderBottom: '2px solid transparent',
    color: '#888', fontWeight: 500,
  },
  tabActive:    { color: '#1D9E75', borderBottomColor: '#1D9E75' },
  formArea:     { padding: '1rem 1.25rem' },
  row2:         { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 },
  input: {
    width: '100%', padding: '8px 10px', fontSize: 14,
    border: '1px solid #ddd', borderRadius: 8,
    background: '#fafafa', color: '#222', outline: 'none',
  },
  btnGuardar: {
    width: '100%', marginTop: 12, padding: 12,
    background: '#1D9E75', color: '#fff', fontSize: 15,
    fontWeight: 600, border: 'none', borderRadius: 10, cursor: 'pointer',
  },
  btnSecundario: {
    marginTop: 12, padding: '8px 20px',
    background: '#E1F5EE', color: '#0F6E56', fontSize: 13,
    border: 'none', borderRadius: 8, cursor: 'pointer',
  },
  empty:      { textAlign: 'center', padding: '2rem 1rem', color: '#aaa' },
  sectionTitle:{ fontSize: 14, fontWeight: 600, color: '#333', margin: '0 0 10px' },
  regCard: {
    background: '#f9f9f9', borderRadius: 10,
    border: '1px solid #eee', padding: '.75rem 1rem', marginBottom: '.6rem',
  },
  regHeader:    { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 },
  catBadge: {
    fontSize: 11, color: '#fff', padding: '2px 8px',
    borderRadius: 6, fontWeight: 500,
  },
  delBtn:       { background: 'none', border: 'none', cursor: 'pointer', fontSize: 16 },
  regNombre:    { fontWeight: 600, fontSize: 14, color: '#222', margin: '2px 0 4px' },
  regMeta: {
    display: 'flex', flexWrap: 'wrap', gap: 10,
    fontSize: 12, color: '#555', marginBottom: 4,
  },
  regPersonal:  { display: 'flex', flexWrap: 'wrap', gap: 8, fontSize: 11, color: '#888' },
  regObs:       { fontSize: 12, color: '#777', fontStyle: 'italic', marginTop: 4 },
  regBy:        { fontSize: 11, color: '#aaa', marginTop: 2 },
  errorMsg:     { background: '#FFF3CD', border: '1px solid #FBBF24', borderRadius: 8, padding: '8px 12px', marginTop: 8, fontSize: 12, color: '#92400E' },
};
